module.exports = __webpack_public_path__ + "img/guide-en-1.4ee1421d.png";